import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-column sm:flex-row sm:align-items-end justify-content-between gutter-s3" }
const _hoisted_2 = { class: "capitalize caption" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "flex sm:flex-column sm:align-items-end justify-content-between"
}
const _hoisted_5 = { class: "caption" }
const _hoisted_6 = { class: "flex align-items-center" }
const _hoisted_7 = { key: 1 }

import { isMilkomedaMainnetOrTestnet } from '@/store/modules/bridge/helpers/cardano-bridge.helper';
import { Blockchain } from '@/store/modules/bridge/models/blockchain';
import { computed, ref } from 'vue';
import { useUtils } from '@/composables/utils/useUtils';
import { useI18n } from 'vue-i18n';
import TokenIcon from '@/components/token/TokenIcon.vue';
import Icon from '@/components/icon/Icon.vue';
import ConnectWalletButton from '@/components/ConnectWalletButton.vue';
import { useCardanoWallet } from '@/store/modules/wallet/useCardanoWallet';
import { useEVMWallet } from '@/store/modules/wallet/useEVMWallet';
import { ToastMessageOptions } from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import { WalletIsNotInstalledError } from '@/sdk/errors';
import NoWalletModal from '@/views/layout/wallet/NoWalletModal.vue';
import { CONNECTORS } from '@/helpers/connectors/wallets/connectors.helper';
import { WALLETS_INSTALL_LINKS } from '@/constants/WALLET_PARAMS';
import WalletConnect from '@/views/layout/wallet/WalletConnect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkPanelHeader',
  props: {
    direction: null,
    blockchain: null
  },
  setup(__props: any) {


const toast = useToast();
const cardanoWallet = useCardanoWallet();
const { walletState: evmWalletState, login: evmWalletLogin } = useEVMWallet();
const { textEllipsis } = useUtils();
const { t } = useI18n();
const isConfirmationDialog = ref(false);
const isMilkomedaWalletInjected = computed(() => evmWalletState.isInjected);
const isCardanoWalletInjected = computed(() => cardanoWallet.isInjected);
const cardanoAddress = computed(() => cardanoWallet.address);
const isNotWallet = ref(false);
const notInstalledWallet = ref();

const openConfirmDialog = () => {
  isConfirmationDialog.value = true;
};
const confirmDisconnect = () => {
  isConfirmationDialog.value = false;
  cardanoWallet.logout();
};

const onCardanoLogin = async (id: string) => {
  const walletName = cardanoWallet.getAvailableConnectorsList[id]?.name;
  try {
    await cardanoWallet.login(walletName);
  } catch (error) {
    toast.removeAllGroups();
    toast.add({
      type: 'danger',
      styleClass: 'bridge',
      summary: t('bridging.error.common'),
      detail: t('error.walletIsNotInstalled', { walletName }),
      installLink: WALLETS_INSTALL_LINKS[walletName],
    } as ToastMessageOptions);
  }
};

const onWalletLogin = async (id: string) => {
  try {
    await evmWalletLogin(id);
  } catch (error) {
    if (error instanceof WalletIsNotInstalledError) {
      notInstalledWallet.value = CONNECTORS[id];
      isNotWallet.value = true;
    }
    console.error(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(__props.direction)), 1),
        _createVNode(TokenIcon, {
          "icon-src": `/images/tokens/${__props.blockchain.icon}.svg`,
          symbol: __props.blockchain.label,
          full: "",
          size: "16",
          class: "text-sm mt-s1"
        }, null, 8, ["icon-src", "symbol"])
      ]),
      (_unref(isMilkomedaMainnetOrTestnet)(__props.blockchain.name))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!_unref(isMilkomedaWalletInjected))
              ? (_openBlock(), _createBlock(WalletConnect, {
                  key: 0,
                  buttonIcon: "",
                  class: "w-full button-base sm:ml-auto sm:w-auto",
                  onOnSelectWallet: _cache[0] || (_cache[0] = id => onWalletLogin(id))
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('wallet.wallet')), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(Icon, {
                      name: "wallet",
                      size: "20",
                      class: "mr-s1 text-secondary"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_unref(textEllipsis)(_unref(evmWalletState).account ?? '', 6, 4)), 1)
                  ])
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!_unref(isCardanoWalletInjected))
              ? (_openBlock(), _createBlock(ConnectWalletButton, {
                  key: 0,
                  class: "w-full button-base sm:ml-auto sm:w-auto",
                  label: _ctx.$t('bridging.connectCardanoWallet'),
                  "button-icon": "",
                  connectors: "cardano",
                  onOnSelectWallet: onCardanoLogin
                }, null, 8, ["label"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "w-full button-base",
                  onClick: openConfirmDialog
                }, {
                  default: _withCtx(() => [
                    _createVNode(Icon, {
                      name: "wallet",
                      size: "20",
                      class: "mr-s1 text-secondary"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_unref(textEllipsis)(_unref(cardanoAddress), 6, 4)), 1)
                  ]),
                  _: 1
                }))
          ])),
      _createVNode(ConfirmDialog, {
        modelValue: isConfirmationDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isConfirmationDialog).value = $event)),
        header: _ctx.$t('bridging.disconnectCardanoWallet'),
        acceptLabel: _ctx.$t('wallet.disconnect'),
        rejectLabel: _ctx.$t('cancel'),
        onAccept: confirmDisconnect
      }, null, 8, ["modelValue", "header", "acceptLabel", "rejectLabel"])
    ]),
    (isNotWallet.value)
      ? (_openBlock(), _createBlock(NoWalletModal, {
          key: 0,
          modelValue: isNotWallet.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isNotWallet).value = $event)),
          name: notInstalledWallet.value.name,
          link: notInstalledWallet.value.link
        }, null, 8, ["modelValue", "name", "link"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})